import { call, put, select, takeLatest } from 'redux-saga/effects';
import { models } from 'powerbi-client';
import getEnvParam from "../../utils/getEnvParam";
import axios from "axios";
import log from "loglevel"
import { requestDefaultJson } from './helpers'
import { decodeTokenJwt } from './authorization';

const REPORT_ID = getEnvParam("REACT_APP_POWER_BI_REPORT_ID");
const WORKSPACE_ID = getEnvParam("REACT_APP_POWER_BI_WORKSPACE_ID");

const GetBearerTokenMicrosoft = (token) => {
  return requestDefaultJson({
    URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + '/idgf/gerar-token',
    method: "GET",
    headers: {
      "NPF_ROUTE": getEnvParam("REACT_APP_HEADER_IDGF"),
      "Authorization": token,
    }
  })
};

const GetGroupMicrosoft = (token) => {
  return new Promise((resolve, reject) => {
    return axios.get(`https://api.powerbi.com/v1.0/myorg/groups/${WORKSPACE_ID}/reports/${REPORT_ID}`, {
      headers: {
        'Content-Type': 'application/json',
        'authorization': `Bearer ${token}`,
      }
    }
    )
      .then(response => response.status !== 200 ? reject(response) : response)
      .then(response => response.data)
      .then(response => resolve(response))
      .catch(error => {
        const response = error?.response?.data
        reject(response);
        log.info(error);
      });
  });
};

const GenerateTokenMicrosoft = (token, datasetId, context) => {
  const data = {
    "datasets": [
      {
        "id": datasetId
      }
    ],
    "reports": [
      {
        "id": REPORT_ID
      }
    ]
  }

  if (context != null && context.idFornecedor != null) {
    data.identities = [
      {
        "username": `${context.idFornecedor}`,
        "roles": ["fFornecedor"],
        "datasets": [`${datasetId}`]
      }
    ]
  }

  return new Promise((resolve, reject) => {
    return axios.post('https://api.powerbi.com/v1.0/myorg/GenerateToken', data, {
      headers: {
        'Content-Type': 'application/json',
        'authorization': `Bearer ${token}`,
      }
    }
    )
      .then(response => response.status !== 200 ? reject(response) : response)
      .then(response => response.data)
      .then(response => resolve(response))
      .catch(error => {
        const response = error?.response?.data
        reject(response);
        log.info(error);
      });
  });
};

function* fetchReportSaga() {
  try {
    yield put({ type: 'SET_EMBED_LOADING' });

    const { token } = yield select(state => state.authentication);
    const context = decodeTokenJwt(token);
    const { access_token } = yield call(GetBearerTokenMicrosoft, token);
    const { embedUrl, datasetId } = yield call(GetGroupMicrosoft, access_token);
    const embedToken = yield call(GenerateTokenMicrosoft, access_token, datasetId, context);

    const embedConfig = {
      type: 'report',
      id: REPORT_ID,
      tokenType: models.TokenType.Embed,
      embedUrl: embedUrl,
      accessToken: embedToken.token,
      pageView: "fitToWidth",
      settings: {
        filterPaneEnabled: false,
        navContentPaneEnabled: false
      }
    };

    yield put({ type: 'SET_EMBED_SUCCESS' });
    yield put({ type: 'SET_EMBED_CONFIG', payload: embedConfig });
  } catch (error) {
    yield put({ type: 'SET_EMBED_FAILURE', payload: error || {error: {message: 'Erro desconhecido', code: ''}} });
  }
}

export function* idgfPowerBiWatcher() {
  yield takeLatest('FETCH_REPORT_REQUEST', fetchReportSaga);
}
